export default __webpack_public_path__ + "static/media/9723d6156b15dfc4d5c2b3137d26eead.png";